import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { JobApplicationViewModel } from 'src/app/_models/generatedModels';
import { JobsService } from 'src/app/_services/generatedServices';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AuthenticationService } from '../_services/authentication.service';
import { AzureFileUploadControl } from '../_controls/image-uploader';
import { NavigationService } from '../_services/navigation-service';
import * as customBuild from 'src/ckCustomBuild/ckeditor';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'bxl-apply-to-job-modal',
  templateUrl: 'apply-to-job-modal.component.html',
})
export class ApplyToJobModalComponent implements OnInit {
  initialized = false;
  @Input() jobId: any;
  @Input() clientIdentifier: string;
  submitComplete: Promise<{}> | undefined;
  public Editor:any = customBuild;
  @ViewChild('theForm', { static: false }) public jobForm: NgForm;
  public formData: JobApplicationViewModel = new JobApplicationViewModel();

  @ViewChild('resumeUploader') resumeUploader: AzureFileUploadControl;
  constructor(
    private activeModal: NgbActiveModal,
    private jobsService: JobsService,
    public auth: AuthenticationService,
    private toastr: ToasterService,
    public navigationService: NavigationService
  ) {}

  htmlEditorConfig = {
    toolbar: {
      items: ['bold', 'italic', 'underline', 'link', 'alignment', 'bulletedList', 'numberedList', '|', 'fontFamily', 'fontSize', 'fontColor', 'fontBackgroundColor', 'SourceEditing'],
      shouldNotGroupWhenFull: false,
    },
    fontSize: {
      options: [9, 11, 13, 'default', 17, 19, 21],
    },
    mediaEmbed: {
      previewsInData: true,
    },
  };

  ngOnInit(): void {
    this.formData.id = 0;
    this.formData.jobId = this.jobId;
    this.formData.coverLetter = '';
    this.formData.resumeAssetPath = '';
    this.populateUserInfo();
    this.initialized = true;
  }

  markAllTouched() {
    Object.keys(this.jobForm.controls).forEach((field) => {
      const control = this.jobForm.control.get(field);
      control.markAsTouched({ onlySelf: true });
      control.markAsDirty({ onlySelf: true });
    });
  }

  apply() {
    if (!this.jobForm.valid) {
      this.markAllTouched();
      this.toastr.error('Please fill in all required fields.', 'Error');
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      this.resumeUploader.Upload().then((result) => {
        this.formData.resumeAssetPath = result.name;

        this.jobsService.apply(this.jobId, this.clientIdentifier, this.formData).subscribe(
          (result) => {
            this.toastr.success('Application submitted successfully!', 'Success');
            this.activeModal.close(result);
              resetButton();
            },
            (error) => {
              this.toastr.error(error.error[0], 'Error');
              resetButton();
            }
          );
      });
    });
  }

  showLogin() {
    this.navigationService.showLogin().then(() => {
      this.auth.fetchUserProfile().subscribe(() => {
        this.populateUserInfo();
      });
    });
  }

  populateUserInfo() {
    let user = this.auth.user;
    this.formData.firstName = user?.firstName || '';
    this.formData.lastName = user?.lastName || '';
    this.formData.emailAddress = user?.email || '';
    this.formData.phoneNumber = user?.phoneNumber || '';
  }

  onCancel() {
    this.activeModal.dismiss();
  }
}
